/** The integration guide is public: an agent author reads it before they have
 *  an account, and the MCP screen links to it from inside the app. */
export const DOC_PATHS = ['/docs/ai'] as const;

export function isDocPath(pathname: string): boolean {
  return DOC_PATHS.some((path) => pathname === path);
}
